import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faArrowRight, 
  faBriefcase,
  faUserGraduate,
  faCalendarAlt,
  faBookOpen,
  faPlay,
  faCheckCircle,
  faStethoscope,
  faHeartPulse,
  faUserNurse
} from '@fortawesome/free-solid-svg-icons';
import '../styles/Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div 
        className="hero-bg" 
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/slider1.jpeg)` }}
      ></div>
      
      {/* Animated Background Shapes */}
      <div className="hero-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
      
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <FontAwesomeIcon icon={faCalendarAlt} />
            <span>Pendaftaran Dibuka 2026</span>
            <span className="badge-dot"></span>
          </div>
          
          <h1>
            Wujudkan Karir <span className="highlight">Profesional</span> di Bidang 
            <span className="highlight-block">Kesehatan</span>
          </h1>
          
          <p>
            STIKES Baramuli mencetak tenaga kesehatan profesional yang kompeten, 
            beretika, dan siap bersaing di era global. Bergabunglah bersama kami 
            untuk masa depan yang lebih cerah.
          </p>
          
          <div className="hero-features">
            <div className="hero-feature">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>Kurikulum Berbasis Kompetensi</span>
            </div>
            <div className="hero-feature">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>Dosen Profesional</span>
            </div>
            <div className="hero-feature">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>Fasilitas Modern</span>
            </div>
          </div>
          
          <div className="hero-buttons">
            <Link to="/pendaftaran" className="btn btn-accent btn-glow">
              <span>Daftar Sekarang</span>
              <FontAwesomeIcon icon={faArrowRight} className="btn-icon" />
            </Link>
            <Link to="/profil" className="btn btn-glass">
              <FontAwesomeIcon icon={faPlay} className="btn-icon-left" />
              <span>Pelajari Lebih Lanjut</span>
            </Link>
          </div>
          
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-icon">
                <FontAwesomeIcon icon={faCalendarAlt} />
              </div>
              <div className="stat-info">
                <h3>20<span>+</span></h3>
                <p>Tahun Pengalaman</p>
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-icon">
                <FontAwesomeIcon icon={faUserGraduate} />
              </div>
              <div className="stat-info">
                <h3>5000<span>+</span></h3>
                <p>Alumni Sukses</p>
              </div>
            </div>
            <div className="stat-item">
              <div className="stat-icon">
                <FontAwesomeIcon icon={faBookOpen} />
              </div>
              <div className="stat-info">
                <h3>3</h3>
                <p>Program Studi</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="hero-visual">
          <div className="hero-visual-main">
            <div className="visual-circle circle-1">
              <FontAwesomeIcon icon={faStethoscope} />
            </div>
            <div className="visual-circle circle-2">
              <FontAwesomeIcon icon={faHeartPulse} />
            </div>
            <div className="visual-circle circle-3">
              <FontAwesomeIcon icon={faUserNurse} />
            </div>
            <div className="visual-center">
              <img src="/images/logo.png" alt="STIKES Baramuli" className="logo-center" />
            </div>
          </div>
          
          <div className="hero-floating-card card-1">
            <div className="floating-card-icon">
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <div className="floating-card-content">
              <div className="floating-card-text">95% Terserap</div>
              <div className="floating-card-sub">Dunia Kerja</div>
            </div>
          </div>
          
          <div className="hero-floating-card card-3">
            <div className="floating-card-icon">
              <FontAwesomeIcon icon={faUserGraduate} />
            </div>
            <div className="floating-card-content">
              <div className="floating-card-text">5000+</div>
              <div className="floating-card-sub">Alumni Sukses</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
